import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { FEATURE_NAME, initialState } from './configs'
import { IWidgetInfo } from './models'

export const widgetSlice = createSlice({
  name: FEATURE_NAME,
  initialState,
  reducers: {
    updateWidgetStatus: (state, action: PayloadAction<IWidgetInfo>) => {
      const { name, status } = action.payload
      state[name].status = status
    },
  },
})

export const { updateWidgetStatus } = widgetSlice.actions

export const widgetReducer = widgetSlice.reducer
